// TextInputSelect.tsx
import React, { useRef } from 'react';
import { Select, Button, Space, Tooltip, message } from 'antd';
import { CopyOutlined, DeleteOutlined } from '@ant-design/icons';

const TOKEN_SEPARATORS = [',', ';', ' ', '\n', '\t'];

const normalizePlate = (s: string) => s.trim().toUpperCase().replace(/\s+/g, '');
const normalizeList = (list: string[]) => Array.from(new Set((list || []).map(normalizePlate).filter(Boolean)));

interface IProps {
  value?: string[];
  placehd?: string;
  onChange?: (v: string[]) => void;
  onBlur?: () => void;
}

const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    // fallback cho http hoặc trình duyệt cũ không có clipboard API
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
  }
};

const TextInputSelect = ({ value, placehd, onChange, onBlur }: IProps) => {
  const searchRef = useRef('');
  const hasValue = !!value?.length;

  const handleCopy = async () => {
    if (!hasValue) return;
    await copyText((value as string[]).join(', '));
    message.success(`Đã copy ${value?.length} giá trị`);
  };

  const handleClear = () => {
    searchRef.current = '';
    onChange?.([]);
  };

  return (
    <div className="flex gap-1" style={{ width: '100%' }}>
      <Select
        mode="tags"
        open={false}
        value={value}
        style={{ width: '100%' }}
        tokenSeparators={TOKEN_SEPARATORS}
        placeholder={placehd ?? 'Nhập biển số rồi Enter, hoặc dán nhiều biển cách nhau dấu , VD: 51A11133'}
        notFoundContent={null}
        onSearch={v => {
          searchRef.current = v;
        }}
        onChange={(vals: string[]) => onChange?.(normalizeList(vals))}
        onBlur={() => {
          const pending = normalizePlate(searchRef.current);
          if (pending) onChange?.(normalizeList([...(value || []), pending]));
          searchRef.current = '';
          onBlur?.();
        }}
      />
      <Tooltip title="Sao chép tất cả">
        <Button
          style={{ padding: 0, height: '30px' }}
          icon={<CopyOutlined size={16} />}
          disabled={!hasValue}
          onClick={handleCopy}
        />
      </Tooltip>
      <Tooltip title="Xóa hết">
        <Button
          style={{ padding: 0, height: '30px' }}
          icon={<DeleteOutlined size={16} />}
          disabled={!hasValue}
          onClick={handleClear}
        />
      </Tooltip>
    </div>
  );
};

export default TextInputSelect;
